import PropTypes from 'prop-types'
import { DownloadCsv } from '../downloadCsv'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import TextEllipsis from '../textEllipsis'
import { PanelDelete } from './PanelDelete'
import { PanelDownloadJpg } from './PanelDownloadJpg'
import classes from './index.module.scss'

export const PanelHeader = ({
  label,
  renderLabel,
  isAllowDragDrop,
  changeLayout,
  renderRightHeader,
  headerStyle,
  downloadJpgParams,
  downloadCsv,
  isShowIconDrag,
}) => {
  return (
    <Element
      elementName="div"
      className={classes.header}
      style={{
        backgroundColor: '#D5D5D5',
        ...headerStyle,
        cursor: isAllowDragDrop ? 'grab' : undefined,
      }}
    >
      <Element className="dFlex alignItemsCenter flex1 minW0">
        {isShowIconDrag && (
          <Icon className="icon-drag" style={{ marginRight: 4 }} />
        )}
        <Element
          className={classes.title}
          elementName="span"
          style={{ color: '#191D25', fontSize: 14 }}
        >
          <TextEllipsis text={label} isI18n={false} />
        </Element>
        {renderLabel ? renderLabel() : null}
      </Element>
      <div className="dFlex alignItemsCenter gap2">
        {renderRightHeader && renderRightHeader()}
        {downloadJpgParams && !downloadCsv && (
          <PanelDownloadJpg data={downloadJpgParams} />
        )}
        {downloadCsv && !downloadJpgParams && (
          <DownloadCsv
            downloadCsv={downloadCsv.downloadFunc}
            disabled={downloadCsv.disabled}
          />
        )}
        {downloadJpgParams && downloadCsv && (
          <DownloadCsv
            downloadCsv={downloadCsv.downloadFunc}
            disabled={downloadCsv.disabled}
          >
            <PanelDownloadJpg data={downloadJpgParams} />
          </DownloadCsv>
        )}
        {isAllowDragDrop && <PanelDelete changeLayout={changeLayout} />}
      </div>
    </Element>
  )
}

PanelHeader.propTypes = {
  label: PropTypes.string,
  renderLabel: PropTypes.func,
  changeLayout: PropTypes.func,
  isAllowDragDrop: PropTypes.bool,
  renderRightHeader: PropTypes.func,
  headerStyle: PropTypes.object,
  downloadJpgParams: PropTypes.shape({
    domId: PropTypes.string,
    arrName: PropTypes.array.isRequired,
    titleJpg: PropTypes.string,
    DownloadComponent: PropTypes.node,
    disabled: PropTypes.bool,
  }),
  downloadCsv: PropTypes.shape({
    downloadFunc: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }),
  iconToolTipLabel: PropTypes.bool,
  contentToolTipLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isShowIconDrag: PropTypes.bool,
}

PanelHeader.defaultProps = {
  label: '',
  changeLayout: () => {},
  isAllowDragDrop: false,
  headerStyle: {},
  isShowIconDrag: false,
}
